export enum TypeRestriction {
  product = 1,
  wagerType = 2,
  sport = 3,
}
